(function() {
	'use strict';

	angular.module('hotransferApp').controller(
			'HoTransferInfoController', HoTransferInfoController);

	HoTransferInfoController.$inject = [ '$scope', '$state',
			'$stateParams','CONST_EXPORTS', '$base64', '$window', 'HoTransferService',
            'CommonService','$http', '$log', 'Upload', 'AlertService','EVENT',
			'authExpiredInterceptor', '$uibModal','NgTableParams' ];

	function HoTransferInfoController($scope, $state, $stateParams,CONST_EXPORTS,
			$base64, $window, HoTransferService,CommonService, $http, $log, Upload,
			AlertService,EVENT, authExpiredInterceptor, $uibModal,NgTableParams) {
		var transferInfoCtr = this;
		var param = $stateParams;
		var typeProcess = $base64.decode(param.typeProcess);
//		$scope.$watch('transferInfoForm', function(form) {
//			transferInfoCtr.validateForm = form;
//		});
		if(param.paramSearch!=null){
			var paramSearch=$base64.decode(param.paramSearch);
		}
		transferInfoCtr.CONST_EXPORTS=CONST_EXPORTS;
		transferInfoCtr.data=[];
		transferInfoCtr.dataRemove=[];
		transferInfoCtr.seriesRemoveLst=[];
		var typeProcess = $base64.decode(param.typeProcess);
		var typeMenu = param.typeMenu;
		transferInfoCtr.approveViewFlag=false;
		transferInfoCtr.approveFlag = false;
		transferInfoCtr.editApproveFlag=false;
		transferInfoCtr.modifyFlag = false;
		transferInfoCtr.createFlag = false;
		transferInfoCtr.editFlag = false;
		transferInfoCtr.detailFlag = false;
		transferInfoCtr.removeFlag = false;
		transferInfoCtr.rejectFlag=false;
		transferInfoCtr.seriesInvalid=false;
		var paramStatus=transferInfoCtr.CONST_EXPORTS.VALUE_NULL;
		var paramCreatedDate=transferInfoCtr.CONST_EXPORTS.VALUE_NULL;
		var paramStockTransfer=transferInfoCtr.CONST_EXPORTS.VALUE_NULL;
		var paramStockRequest=transferInfoCtr.CONST_EXPORTS.VALUE_NULL;
		var paramStockTransferCode=transferInfoCtr.CONST_EXPORTS.VALUE_NULL;
		if(paramSearch!=undefined){
			var splitted = paramSearch.split(transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON);
			for(var i=0;i<splitted.length;i++){
				var paramSpit=splitted[i].split(transferInfoCtr.CONST_EXPORTS.SIGN_COLON);
				if(paramSpit[0]==transferInfoCtr.CONST_EXPORTS.PARAM_STATUS){
					paramStatus=paramSpit[1];
				}
				if(paramSpit[0]==transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE){
					paramStockTransferCode=paramSpit[1];
				}
				if(paramSpit[0]==transferInfoCtr.CONST_EXPORTS.PARAM_CREATE_DATE){
					paramCreatedDate=paramSpit[1];
				}
				if(paramSpit[0]==transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST){
					paramStockRequest=paramSpit[1];
				}
				if(paramSpit[0]==transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER){
					paramStockTransfer=paramSpit[1];
				}
			}
		}
		var countButton=0;
		$scope.loading = false;
		$scope.$on(EVENT.changeOffice, function(event, args) {
			if(event.name = 'CHANGE_OFFICE') {
				$state.go($state.current, {}, {reload: true});
			}
		});
		transferInfoCtr.statusLst = HoTransferService.query({
			uri : 'getAllStatus'
		});
		transferInfoCtr.dateOptions = {
			minDate : new Date()
		};
		transferInfoCtr.dod = new Date();
		transferInfoCtr.openDod = function() {
			transferInfoCtr.popupDod.opened = true;
		};
		transferInfoCtr.info = function() {
			window.location.href = GLOBAL_URL
			+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
			+ '/'
			+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW;
		};
		transferInfoCtr.cancel = function() {
			if(typeMenu==transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW){
				if(paramSearch!=undefined){
					window.location.href = GLOBAL_URL
					+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
					+ '/'
					+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW
					+ '/'
					+ $base64
							.encode(paramSearch);
				}else{
					window.location.href = GLOBAL_URL
					+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
					+ '/'
					+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW;
				}
			}else{
				if(paramSearch!=undefined){
					window.location.href = GLOBAL_URL
					+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
					+ '/'
					+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW
					+ '/'
					+ $base64
							.encode(paramSearch);
				}else{
					window.location.href = GLOBAL_URL
					+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
					+ '/'
					+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW;
				}
			}
		};
		transferInfoCtr.changeRemoveView=function(){
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					var typeProcess = transferInfoCtr.CONST_EXPORTS.REMOVE_STATUS_CODE;
					paramSearch=transferInfoCtr.CONST_EXPORTS.VALUE_NULL;
					if(paramStockRequest!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockRequest;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockRequest;
						}
					}
					if(paramStockTransfer!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockTransfer;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockTransfer;
						}			
					}
					if(paramCreatedDate!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramCreatedDate;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramCreatedDate;
						}
					}
					if(paramStatus!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_STATUS+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStatus;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_STATUS+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStatus;
						}
					}
					if(paramStockTransferCode!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockTransferCode;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockTransferCode;
						}
					}
					window.location.href = GLOBAL_URL
								+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
								+ '/'
								+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW 
								+ '/'
								+ $base64.encode(typeProcess)
					            + '/'
								+ $base64.encode(paramSearch)
								+ '/'
					            + param.stockTransferCode;
				}else{
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		}
		transferInfoCtr.changeEditView=function(){
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					var typeProcess = transferInfoCtr.CONST_EXPORTS.EDIT_STATUS_CODE
					paramSearch=transferInfoCtr.CONST_EXPORTS.VALUE_NULL;
					if(paramStockRequest!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockRequest;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_REQUEST+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockRequest;
						}
					}
					if(paramStockTransfer!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockTransfer;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockTransfer;
						}			
					}
					if(paramCreatedDate!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramCreatedDate;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_CREATE_DATE+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramCreatedDate;
						}
					}
					if(paramStatus!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_STATUS+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStatus;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_STATUS+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStatus;
						}
					}
					if(paramStockTransferCode!=transferInfoCtr.CONST_EXPORTS.VALUE_NULL){
						if(paramSearch!=''){
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.SIGN_SEMICOLON+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockTransferCode;
						}else{
							paramSearch=paramSearch+transferInfoCtr.CONST_EXPORTS.PARAM_STOCK_TRANSFER_CODE+transferInfoCtr.CONST_EXPORTS.SIGN_COLON+paramStockTransferCode;
						}
					}
					window.location.href = GLOBAL_URL
								+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
								+ '/'
								+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW 
								+ '/'
								+ $base64.encode(typeProcess)
					            + '/'
								+ $base64.encode(paramSearch)
								+ '/'
					            + param.stockTransferCode;
				}else{
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		}
		transferInfoCtr.changeRequest=function(){
			var stockTransferId=transferInfoCtr.stockTransferDTO.stockId;
			HoTransferService.query({
				uri : 'getAllExcludedStockId',stockId: transferInfoCtr.stockRequestDTO.stockId
			}).$promise.then(function(result){
				transferInfoCtr.transferRequestDTO.stockTransferLst=result;
				transferInfoCtr.stockTransferDTO=transferInfoCtr.getItemIdArray(result,stockTransferId);
				transferInfoCtr.data=[];
				transferInfoCtr.tableParams.data=[];
				transferInfoCtr.transferRequestDTO.receiverName=transferInfoCtr.stockRequestDTO.receiverName1;
				transferInfoCtr.addProduct();
			});
		};
		transferInfoCtr.changeTransfer=function(){
			var stockRequestId=transferInfoCtr.stockRequestDTO.stockId;
			HoTransferService.query({
				uri : 'getAllByOfficeExcludedStockId',stockId: transferInfoCtr.stockTransferDTO.stockId
			}).$promise.then(function(result){
				if(transferInfoCtr.createFlag){
					transferInfoCtr.transferRequestDTO.stockRequestLst=result;
					transferInfoCtr.transferRequestDTO.stockTransferId=transferInfoCtr.stockTransferDTO.stockId;
					transferInfoCtr.stockRequestDTO=transferInfoCtr.getItemIdArray(result,stockRequestId);
				}
				if(typeProcess== transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_CODE)
				{
					transferInfoCtr.data=[];
					transferInfoCtr.tableParams.data=[];
					transferInfoCtr.addProduct();
				}else{
					HoTransferService.post({
						uri : 'getAvailableStockTrans'},transferInfoCtr.transferRequestDTO
									,function(result){
							transferInfoCtr.tableParams = new NgTableParams({
								count : result.detailLst.length
							// hides pager
							}, {
								counts : [], // hide page counts control
								filterDelay : 0,
								dataset : result.detailLst
							});

				});
				}
			});
		};
//		transferInfoCtr.changeRequest=function(index){
//			if(transferInfoCtr.tableParams.data[index].requestQuantity>0){
//				transferInfoCtr.validateForm.requestQuantity[index].$error.pattern=false;
//			}
//		}
		transferInfoCtr.addRow = function(seriesLst) {
			transferInfoCtr.showMinus = true;
			var id = seriesLst.length + 1;
			var seri = {
				idSeries : id,
				seriesFrom : '',
				seriesTo : ''
			}
			seriesLst.push(seri);
		};
		transferInfoCtr.removeRow = function(seriesLst, indexSeries) {
			var length = seriesLst.length;
			var indexPop = -1;
			for (var i = 0; i < length; i++) {
				var ser = seriesLst[i];
				if (ser.idSeries == indexSeries) {
					indexPop = i;
					break;
				}
			}
			if (indexPop > -1&&seriesLst.length>1) {
				if(seriesLst[indexPop].requestId!=undefined&&seriesLst[indexPop].requestId!=null){
					transferInfoCtr.seriesRemoveLst.push(seriesLst[indexPop]);
				}
				seriesLst.splice(indexPop, 1);
				length = seriesLst.length;
				if (length == 1) {
					transferInfoCtr.showMinus = false;
				}
			}
		};
		transferInfoCtr.getItemIdArray = function(array, stockId) {
			if (stockId == null || stockId == undefined || stockId == '') {
				return "";
			}		
			try {
				var obj = array.filter(function(val) {
					return val.stockId === stockId;
				});
				return obj[0];
			} catch (e) {

			}			
		};
		transferInfoCtr.getItemStatusArray = function(array, code) {
			if (code == null || code == undefined || code == '') {
				return "";
			}		
			try {
				var obj = array.filter(function(val) {
					return val.statusCode === code;
				});
				return obj[0].statusName;
			} catch (e) {

			}			
		};
		transferInfoCtr.getItemProductArray = function(array, productId) {
			if (productId == null || productId == undefined || productId == '') {
				return "";
			}		
			try {
				var obj = array.filter(function(val) {
					return val.productId === productId;
				});
				return obj[0];
			} catch (e) {

			}			
		};
		transferInfoCtr.changeProductGroup=function(index){
			CommonService.query({masterurl:'find-product-active-by-group',productGroupId : transferInfoCtr.tableParams.data[index].productGroupId}).$promise.then(function(result){
				if(result.length>0){
					transferInfoCtr.tableParams.data[index].productLst=result;
					transferInfoCtr.tableParams.data[index].productId=result[0].productId;
					HoTransferService.get({
						uri : 'getAvailableStock',stockId:transferInfoCtr.stockRequestDTO.stockId,productId:transferInfoCtr.tableParams.data[index].productId
					},function(result){
						transferInfoCtr.tableParams.data[index].avQuantityReq=result.availableStock;
					});
					HoTransferService.get({
						uri : 'getAvailableStock',stockId:transferInfoCtr.stockTransferDTO.stockId,productId:transferInfoCtr.tableParams.data[index].productId
					},function(result){
						transferInfoCtr.tableParams.data[index].avQuantityTrans=result.availableStock;
					});
				}else{
					transferInfoCtr.tableParams.data[index].productLst=null;
					transferInfoCtr.tableParams.data[index].productId=null;
					transferInfoCtr.tableParams.data[index].avQuantityReq=null;
					transferInfoCtr.tableParams.data[index].avQuantityTrans=null;
					$scope.addAlert('Nhóm sản phẩm này chưa có sản phẩm.Vui lòng chọn nhóm sản phẩm khác!','error');
				}
			});
		}
		transferInfoCtr.changeProduct=function(index){
			HoTransferService.get({
				uri : 'getAvailableStock',stockId:transferInfoCtr.stockRequestDTO.stockId,productId:transferInfoCtr.tableParams.data[index].productId
			},function(result){
				transferInfoCtr.tableParams.data[index].avQuantityReq=result.availableStock;
			});
			HoTransferService.get({
				uri : 'getAvailableStock',stockId:transferInfoCtr.stockTransferDTO.stockId,productId:transferInfoCtr.tableParams.data[index].productId
			},function(result){
				transferInfoCtr.tableParams.data[index].avQuantityTrans=result.availableStock;
			});
		}
		transferInfoCtr.addProduct = function() {
			CommonService.query({masterurl:'product-group-active'}).$promise.then(function(result) {
					var productGroupLst = result;
	            	CommonService.query({masterurl:'find-product-active-by-group',productGroupId: productGroupLst[0].productGroupId}).$promise.then(function(result){
						var productLst = result;
						HoTransferService.get({
							uri : 'getAvailableStock',stockId:transferInfoCtr.stockRequestDTO.stockId,productId:productLst[0].productId
						}).$promise.then(function(result){
							var avQuantityReq=result.availableStock;
							HoTransferService.get({
								uri : 'getAvailableStock',stockId:transferInfoCtr.stockTransferDTO.stockId,productId:productLst[0].productId
							}).$promise.then(function(result){
								var item;
								item = {
									productGroupId : productGroupLst[0].productGroupId,
									productId : productLst[0].productId,
									avQuantityTrans : result.availableStock,
									avQuantityReq : avQuantityReq,
									requestQuantity : 1,
									printDetail : '',
									productGroupLst : productGroupLst,
									productLst : productLst
								};
								transferInfoCtr.data.push(item);
								transferInfoCtr.tableParams = new NgTableParams({
									count : transferInfoCtr.data.length
								// hides pager
								}, {
									counts : [], // hide page counts control
									filterDelay : 0,
									dataset : transferInfoCtr.data
								});
								if(typeMenu==transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW){
									HoTransferService.query({uri:'transport-type-active'},function(result){
										var itemConfirm;
										var seriesLst=[]
										var seri = {
											idSeries : 1,
											seriesFrom : '',
											seriesTo : ''
										}
										seriesLst.push(seri);
										itemConfirm = {
												productGroupId : productGroupLst[0].productGroupId,
												productId : productLst[0].productId,
												approvalQuantity : 1,
												seriesLst : seriesLst,
												transportTypeLst : result,
												transportTypeId : result[0].transportTypeId,
												notes : ''
										};
										transferInfoCtr.transferRequestDTO.detailAppLst(itemConfirm);
										transferInfoCtr.tableParamsConfirm = new NgTableParams({
											count : transferInfoCtr.transferRequestDTO.detailAppLst.length
										// hides pager
										}, {
											counts : [], // hide page counts control
											filterDelay : 0,
											dataset : transferInfoCtr.transferRequestDTO.detailAppLst
										});
									});
								}
							});
						});
					},function(error) {

		            });
	            }, function(error) {

	            });
		}
		transferInfoCtr.deleteProduct = function(idx,event) {
			var modalInstance = $uibModal.open({
			      animation: $scope.animationsEnabled,
			      templateUrl: GLOBAL_URL
					+ 'partial?uri=e-stock/hotransfer/template/hotransfer-delete-dialog',
			      controller: 'HoTransferDeleteDialogController as deleteHoTransferCtr',
			      size: 'mi',
			      resolve: {
			      }
			    });

				 modalInstance.result.then(function (checkItem) {
				    	if(checkItem){
				    		if (transferInfoCtr.tableParams.data.length > 1) {
								if(transferInfoCtr.tableParams.data[idx].stockTransRqDtId!=null){
									transferInfoCtr.dataRemove.push(transferInfoCtr.tableParams.data[idx]);
								}
								transferInfoCtr.tableParams.data.splice(idx, 1);
								transferInfoCtr.data.splice(idx, 1);
								transferInfoCtr.tableParams.reload();
							}
				    	}
				    }, function () {
				    });
	   
		}
		
		transferInfoCtr.changeReject=function(){
			if(transferInfoCtr.transferRequestDTO.declineReason!=null&&transferInfoCtr.transferRequestDTO.declineReason!=undefined&&transferInfoCtr.transferRequestDTO.declineReason!=''){
				transferInfoCtr.rejectFlag=false;
			}else{
				transferInfoCtr.rejectFlag=true;
			}
		}
		if(typeMenu==transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW){
			if (typeProcess == transferInfoCtr.CONST_EXPORTS.EDIT_STATUS_CODE) {
				$window.document.title = transferInfoCtr.CONST_EXPORTS.EDIT_STATUS_NAME;
				transferInfoCtr.editFlag = true;
				HoTransferService.get({
					uri : 'getRequestByCode',transferCode:$base64.decode(param.stockTransferCode),status:transferInfoCtr.CONST_EXPORTS.STATUS_DISABLE
				}, function(result) {
						transferInfoCtr.transferRequestDTO = result;
						transferInfoCtr.transferRequestDTO.statusName=transferInfoCtr.getItemStatusArray(transferInfoCtr.statusLst,result.status);
						transferInfoCtr.stockRequestDTO=transferInfoCtr.getItemIdArray(result.stockRequestLst,transferInfoCtr.transferRequestDTO.stockRequestId);
						transferInfoCtr.stockTransferDTO=transferInfoCtr.getItemIdArray(result.stockTransferLst,transferInfoCtr.transferRequestDTO.stockTransferId);
						transferInfoCtr.data=transferInfoCtr.transferRequestDTO.detailLst;
						transferInfoCtr.tableParams = new NgTableParams({
							count : transferInfoCtr.transferRequestDTO.detailLst.length
						// hides pager
						}, {
							counts : [], // hide page counts control
							filterDelay : 0,
							dataset : transferInfoCtr.transferRequestDTO.detailLst
						});			
					}, function(error) {
				});
			}
			if (typeProcess == transferInfoCtr.CONST_EXPORTS.VIEW_STATUS_CODE) {
				$window.document.title = transferInfoCtr.CONST_EXPORTS.VIEW_STATUS_NAME;
				transferInfoCtr.detailFlag = true;
				HoTransferService.get({
					uri : 'getRequestByCode',transferCode:$base64.decode(param.stockTransferCode),status:transferInfoCtr.CONST_EXPORTS.STATUS_ENABLE
				}, function(result) {
					transferInfoCtr.transferRequestDTO = result;
					transferInfoCtr.transferRequestDTO.statusName=transferInfoCtr.getItemStatusArray(transferInfoCtr.statusLst,result.status);
					transferInfoCtr.stockRequestDTO=transferInfoCtr.getItemIdArray(result.stockRequestLst,transferInfoCtr.transferRequestDTO.stockRequestId);
					transferInfoCtr.stockTransferDTO=transferInfoCtr.getItemIdArray(result.stockTransferLst,transferInfoCtr.transferRequestDTO.stockTransferId);
					transferInfoCtr.tableParams = new NgTableParams({
						count : transferInfoCtr.transferRequestDTO.detailLst.length
					// hides pager
					}, {
						counts : [], // hide page counts control
						filterDelay : 0,
						dataset : transferInfoCtr.transferRequestDTO.detailLst
					});	
					transferInfoCtr.tableParamsConfirm = new NgTableParams({
						count : transferInfoCtr.transferRequestDTO.detailAppLst.length
					// hides pager
					}, {
						counts : [], // hide page counts control
						filterDelay : 0,
						dataset : transferInfoCtr.transferRequestDTO.detailAppLst
					});
					}, function(error) {
				});
			}
			if (typeProcess == transferInfoCtr.CONST_EXPORTS.REMOVE_STATUS_CODE) {
				$window.document.title = transferInfoCtr.CONST_EXPORTS.REMOVE_STATUS_NAME;
				transferInfoCtr.removeFlag = true;
				HoTransferService.get({
					uri : 'getRequestByCode',transferCode:$base64.decode(param.stockTransferCode),status:transferInfoCtr.CONST_EXPORTS.STATUS_DISABLE
				}, function(result) {
					transferInfoCtr.transferRequestDTO = result;
					transferInfoCtr.transferRequestDTO.statusName=transferInfoCtr.getItemStatusArray(transferInfoCtr.statusLst,result.status);
					transferInfoCtr.stockRequestDTO=transferInfoCtr.getItemIdArray(result.stockRequestLst,transferInfoCtr.transferRequestDTO.stockRequestId);
					transferInfoCtr.stockTransferDTO=transferInfoCtr.getItemIdArray(result.stockTransferLst,transferInfoCtr.transferRequestDTO.stockTransferId);
					transferInfoCtr.tableParams = new NgTableParams({
						count : transferInfoCtr.transferRequestDTO.detailLst.length
					// hides pager
					}, {
						counts : [], // hide page counts control
						filterDelay : 0,
						dataset : transferInfoCtr.transferRequestDTO.detailLst
					});			
					}, function(error) {
				});
			}
			if (typeProcess== transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_CODE) {
				$window.document.title = transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_NAME;
				HoTransferService.query({
					uri : 'getStockByOffice'
				}).$promise.then(function(result){
					if(result[0].flagError==0){
						var stockRequestLst=result;
//						stockRequestLst.push(result);
						HoTransferService.query({
							uri : 'getAllExcludedStockId',stockId:stockRequestLst[0].stockId
						},function(result){
							var stockTransferLst=result;
							transferInfoCtr.stockRequestDTO=stockRequestLst[0];
							transferInfoCtr.stockTransferDTO=stockTransferLst[0];
							transferInfoCtr.transferRequestDTO ={statusName:transferInfoCtr.statusLst[0].statusName,
									status:transferInfoCtr.statusLst[0].statusCode,
									createdDate : new Date(),
									createdName : $scope.$parent.appCtrl.account.fullName,
									stockRequestId: transferInfoCtr.stockRequestDTO.stockId,
									stockTransferId: transferInfoCtr.stockTransferDTO.stockId,
									stockRequestLst: [],
									stockTransferLst: stockTransferLst,
									receiverName:transferInfoCtr.stockRequestDTO.receiverName1,
									departmentRequest:$scope.$parent.appCtrl.account.department
							};
							for(var i=0;i<stockRequestLst.length;i++){
//								  if(stockRequestLst[i].stockId != transferInfoCtr.transferRequestDTO.stockTransferLst[0].stockId) {
									  transferInfoCtr.transferRequestDTO.stockRequestLst.push(stockRequestLst[i]);
//								  }
							}
							transferInfoCtr.createFlag = true;
							transferInfoCtr.addProduct();
						});
					}else{
						$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
					}
				});
			}
		}else{
			transferInfoCtr.approveViewFlag=true;
			if (typeProcess == transferInfoCtr.CONST_EXPORTS.MODIFY_STATUS_CODE) {
				$window.document.title = transferInfoCtr.CONST_EXPORTS.MODIFY_STATUS_NAME;
				transferInfoCtr.approveFlag = true;
				transferInfoCtr.editApproveFlag=true;
				HoTransferService.get({
					uri : 'getRequestApproveByCode',transferCode:$base64.decode(param.stockTransferCode)
				}).$promise.then(function(result) {
					if(result.status!=transferInfoCtr.CONST_EXPORTS.WAIT_IMPORT){
						transferInfoCtr.transferRequestDTO = result;
						transferInfoCtr.transferRequestDTO.statusName=transferInfoCtr.getItemStatusArray(transferInfoCtr.statusLst,transferInfoCtr.transferRequestDTO.status);
						transferInfoCtr.stockRequestDTO=transferInfoCtr.getItemIdArray(transferInfoCtr.transferRequestDTO.stockRequestLst,transferInfoCtr.transferRequestDTO.stockRequestId);
						transferInfoCtr.stockTransferDTO=transferInfoCtr.getItemIdArray(transferInfoCtr.transferRequestDTO.stockTransferLst,transferInfoCtr.transferRequestDTO.stockTransferId);
						transferInfoCtr.tableParams = new NgTableParams({
							count : transferInfoCtr.transferRequestDTO.detailLst.length
							// hides pager
						}, {
							counts : [], // hide page counts control
							filterDelay : 0,
							dataset : transferInfoCtr.transferRequestDTO.detailLst
						});
						transferInfoCtr.tableParamsConfirm = new NgTableParams({
							count : transferInfoCtr.transferRequestDTO.detailAppLst.length
							// hides pager
						}, {
							counts : [], // hide page counts control
							filterDelay : 0,
							dataset : transferInfoCtr.transferRequestDTO.detailAppLst
						});
					}else{
						transferInfoCtr.detailFlag = true;
						transferInfoCtr.approveViewFlag=false;
						transferInfoCtr.approveFlag = false;
						transferInfoCtr.editApproveFlag=false;
						transferInfoCtr.detailFlag = true;
						HoTransferService.get({
							uri : 'getRequestByCode',transferCode:$base64.decode(param.stockTransferCode),status:transferInfoCtr.CONST_EXPORTS.STATUS_DISABLE
						}, function(result) {
							transferInfoCtr.transferRequestDTO = result;
							transferInfoCtr.transferRequestDTO.statusName=transferInfoCtr.getItemStatusArray(transferInfoCtr.statusLst,result.status);
							transferInfoCtr.stockRequestDTO=transferInfoCtr.getItemIdArray(result.stockRequestLst,transferInfoCtr.transferRequestDTO.stockRequestId);
							transferInfoCtr.stockTransferDTO=transferInfoCtr.getItemIdArray(result.stockTransferLst,transferInfoCtr.transferRequestDTO.stockTransferId);
							transferInfoCtr.tableParams = new NgTableParams({
								count : transferInfoCtr.transferRequestDTO.detailLst.length
							// hides pager
							}, {
								counts : [], // hide page counts control
								filterDelay : 0,
								dataset : transferInfoCtr.transferRequestDTO.detailLst
							});			
							}, function(error) {
						});
					}
				}, function(error) {
						
					
				});
			}
			if (typeProcess == transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_CODE) {
				$window.document.title = transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_NAME;
				transferInfoCtr.approveFlag = true;
				HoTransferService.get({
					uri : 'getRequestByCode',transferCode:$base64.decode(param.stockTransferCode),status:transferInfoCtr.CONST_EXPORTS.STATUS_DISABLE
				}).$promise.then(function(result) {
					transferInfoCtr.transferRequestDTO = result;
					HoTransferService.query({uri:'transport-type-active'},function(result){
						transferInfoCtr.transferRequestDTO.statusName=transferInfoCtr.getItemStatusArray(transferInfoCtr.statusLst,transferInfoCtr.transferRequestDTO.status);
						transferInfoCtr.stockRequestDTO=transferInfoCtr.getItemIdArray(transferInfoCtr.transferRequestDTO.stockRequestLst,transferInfoCtr.transferRequestDTO.stockRequestId);
						transferInfoCtr.stockTransferDTO=transferInfoCtr.getItemIdArray(transferInfoCtr.transferRequestDTO.stockTransferLst,transferInfoCtr.transferRequestDTO.stockTransferId);
						transferInfoCtr.tableParams = new NgTableParams({
							count : transferInfoCtr.transferRequestDTO.detailLst.length
						// hides pager
						}, {
							counts : [], // hide page counts control
							filterDelay : 0,
							dataset : transferInfoCtr.transferRequestDTO.detailLst
						});
						for(var index=0;index<transferInfoCtr.transferRequestDTO.detailLst.length;index++){
							var itemConfirm;
							var seriesLst=[]
							var seri = {
								idSeries : 1,
								seriesFrom : '',
								seriesTo : ''
							}
							seriesLst.push(seri);
							itemConfirm = {
									stockTransRqDtId : transferInfoCtr.transferRequestDTO.detailLst[index].stockTransRqDtId,
									productGroupId : transferInfoCtr.transferRequestDTO.detailLst[index].productGroupId,
									productId : transferInfoCtr.transferRequestDTO.detailLst[index].productId,
									approvalQuantity : 1,
									seriesLst : seriesLst,
									transportTypeLst : result,
									transportTypeId : result[0].transportTypeId,
									notes : '',
									productGroupLst:transferInfoCtr.transferRequestDTO.detailLst[index].productGroupLst,
									productLst:transferInfoCtr.transferRequestDTO.detailLst[index].productLst
							};
							transferInfoCtr.transferRequestDTO.detailAppLst.push(itemConfirm);
						}
						transferInfoCtr.tableParamsConfirm = new NgTableParams({
							count : transferInfoCtr.transferRequestDTO.detailAppLst.length
						// hides pager
						}, {
							counts : [], // hide page counts control
							filterDelay : 0,
							dataset : transferInfoCtr.transferRequestDTO.detailAppLst
						});
					});
				}, function(error) {
						
					
				});
			}
		}
		transferInfoCtr.changeSeries=function(){
			if(transferInfoCtr.seriesInvalid){
				transferInfoCtr.seriesInvalid=false;
			}
		}
		transferInfoCtr.changeApprove=function(){
			if(transferInfoCtr.seriesInvalid){
				transferInfoCtr.seriesInvalid=false;
			}
		}
		//action request from server side
		//action create request
		transferInfoCtr.create = function() {
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					if(countButton==0){
						countButton=countButton+1;
						if(transferInfoCtr.editFlag){
							$scope.loading = true;
							transferInfoCtr.transferRequestDTO.stockTransferId=transferInfoCtr.stockTransferDTO.stockId;
							transferInfoCtr.transferRequestDTO.detailLst=transferInfoCtr.tableParams.data;
							transferInfoCtr.transferRequestDTO.detailRemoveLst=transferInfoCtr.dataRemove;
							HoTransferService.post({
								uri : 'doEditRequest'
							}, transferInfoCtr.transferRequestDTO, function(result) {
								if (result.flagError!=null&&result.flagError==1) {
									$scope.loading = false;
									countButton=0;
								}else{
									if(paramSearch!=undefined){
										window.location.href = GLOBAL_URL
										+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
										+ '/'
										+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW
										+ '/'
										+ $base64
												.encode(paramSearch);
									}else{
										window.location.href = GLOBAL_URL
										+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
										+ '/'
										+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW;
									}
									$scope.loading = false;
								}
							}, function(error) {
								if(error.status == '403') {
									$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
								}
								$scope.loading = false;
							});
						}else{
							$scope.loading = true;
							transferInfoCtr.transferRequestDTO.stockRequestId=transferInfoCtr.stockRequestDTO.stockId;
							transferInfoCtr.transferRequestDTO.detailLst=transferInfoCtr.tableParams.data;
							HoTransferService.post({
								uri : 'doCreateRequest'
							}, transferInfoCtr.transferRequestDTO, function(result) {
								if (result.flagError!=null&&result.flagError==1) {
									countButton=0;
									$scope.loading = false;
								}else{
									if(paramSearch!=undefined){
										window.location.href = GLOBAL_URL
										+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
										+ '/'
										+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW
										+ '/'
										+ $base64
												.encode(paramSearch);
									}else{
										window.location.href = GLOBAL_URL
										+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
										+ '/'
										+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW;
									}
									$scope.loading = false;	
								}
							}, function(error) {
								if(error.status == '403') {
									$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
								}
								$scope.loading = false;
							});
						}
					}
				}else{
					$scope.loading = false;
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		}
		//action remove request
		transferInfoCtr.remove = function() {
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					$scope.loading = true;
					transferInfoCtr.transferRequestDTO.detailLst=transferInfoCtr.tableParams.data;
					HoTransferService.post({
						uri : 'doRemoveRequest'
					}, transferInfoCtr.transferRequestDTO, function(result) {
						if (result.flagError!=null&&result.flagError==0) {
							if(paramSearch!=undefined){
								window.location.href = GLOBAL_URL
								+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
								+ '/'
								+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW
								+ '/'
								+ $base64
										.encode(paramSearch);
							}else{
								window.location.href = GLOBAL_URL
								+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
								+ '/'
								+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW;
							}
							$scope.loading = false;
						}else{
							$scope.loading = false;	
						}
					}, function(error) {
						$scope.loading = false;
					});
				}else{
					$scope.loading = false;
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		}
		
		//action roll back request
		transferInfoCtr.rollBack = function() {
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					$scope.loading = false;
					transferInfoCtr.transferRequestDTO.detailLst=transferInfoCtr.tableParams.data;
					var modalInstance = $uibModal.open({
					      animation: $scope.animationsEnabled,
					      templateUrl: GLOBAL_URL
							+ 'partial?uri=e-stock/hotransfer/template/hotransfer-rollback-dialog',
					      controller: 'HoTransferRollbackDialogController as rollbackHoTransferCtr',
					      size: 'mi',
					      resolve : {
								transferRequestDTO: function(){
									return transferInfoCtr.transferRequestDTO;
								}
							}
					    });
						modalInstance.result.then(function (checkItem) {
						    	if(checkItem){
						    			if(paramSearch!=undefined){
											window.location.href = GLOBAL_URL
											+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
											+ '/'
											+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW
											+ '/'
											+ $base64
													.encode(paramSearch);
										}else{
											window.location.href = GLOBAL_URL
											+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
											+ '/'
											+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW;
										}
										$scope.loading = false;
									}else{
										$scope.loading = false;	
									}
					}, function(error) {
						$scope.loading = false;
					});
				}else{
					$scope.loading = false;
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		}
		//action reject request
		transferInfoCtr.reject = function() {
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					$scope.loading = true;
					if(transferInfoCtr.transferRequestDTO.declineReason!=null&&transferInfoCtr.transferRequestDTO.declineReason!=undefined&&transferInfoCtr.transferRequestDTO.declineReason!=''){
						transferInfoCtr.rejectFlag=false;
						HoTransferService.post({
							uri : 'doRejectRequest'
						}, transferInfoCtr.transferRequestDTO, function(result) {
							if (result.flagError!=null&&result.flagError==0) {
								if(paramSearch!=undefined){
									window.location.href = GLOBAL_URL
									+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
									+ '/'
									+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW
									+ '/'
									+ $base64
											.encode(paramSearch);
								}else{
									window.location.href = GLOBAL_URL
									+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
									+ '/'
									+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW;
								}
								$scope.loading = false;
							}else{
								$scope.loading = false;	
							}
						}, function(error) {
							$scope.loading = false;
						});
					}else{
						transferInfoCtr.rejectFlag=true;
						$scope.loading = false;	
					}
				}else{
					$scope.loading = false;
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		}
		
		//action approve request
		transferInfoCtr.approve = function() {
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					if(typeProcess == transferInfoCtr.CONST_EXPORTS.MODIFY_STATUS_CODE){
						$scope.loading = true;
						var totalApprovalQuantity=0;
						for(var i=0;i<transferInfoCtr.tableParamsConfirm.data.length;i++){
							var item=transferInfoCtr.tableParamsConfirm.data[i];
							var quantity = 0;
							totalApprovalQuantity=totalApprovalQuantity+parseInt(item.approvalQuantity);
							if(parseInt(item.approvalQuantity)>0){
								if(transferInfoCtr.getItemProductArray(item.productLst,item.productId).seriesIndicator==1){
									for (var j = 0, length = item.seriesLst.length; j < length; j++) {
										var seriesDTO = item.seriesLst[j];
										if (parseInt(seriesDTO.seriesFrom) > parseInt(seriesDTO.seriesTo)) {
											$scope.addAlert('Từ số seri phải nhỏ hơn đến số seri.','error');
											transferInfoCtr.seriesInvalid=true;
											break;
										}
										var minusSeries = parseInt(seriesDTO.seriesTo) - parseInt(seriesDTO.seriesFrom) + 1;
										quantity += minusSeries;
									}
									if(!transferInfoCtr.seriesInvalid){
										if (quantity != parseInt(item.approvalQuantity)) {
											$scope.addAlert('Số seri không bằng số lượng duyệt, vui lòng xem lại!',
													'error');
											transferInfoCtr.seriesInvalid=true;
											break;
										}
									}
								}
							}
						}
						if(totalApprovalQuantity>0){
							if(!transferInfoCtr.seriesInvalid){
								transferInfoCtr.transferRequestDTO.seriesRemoveLst=transferInfoCtr.seriesRemoveLst;
								transferInfoCtr.transferRequestDTO.detailAppLst=transferInfoCtr.tableParamsConfirm.data;
								HoTransferService.post({
									uri : 'doEditApproveRequest'
								}, transferInfoCtr.transferRequestDTO, function(result) {
									if (result.flagError!=null&&result.flagError==0) {
										if(paramSearch!=undefined){
											window.location.href = GLOBAL_URL
											+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
											+ '/'
											+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW
											+ '/'
											+ $base64
													.encode(paramSearch);
										}else{
											window.location.href = GLOBAL_URL
											+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
											+ '/'
											+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW;
										}
										$scope.loading = false;
									}else{
										$scope.loading = false;	
									}
								}, function(error) {
									if(error.status == '403') {
										$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
									}
									$scope.loading = false;
								});
							}else{
								$scope.loading = false;
							}
						}else{
							$scope.loading = false;
							$scope.addAlert('Tổng số lượng duyệt phải lớn hơn 0.Vui lòng kiểm tra lại','error');
						}
					}else{
						$scope.loading = true;
						var totalApprovalQuantity=0;
						for(var i=0;i<transferInfoCtr.tableParamsConfirm.data.length;i++){
							var item=transferInfoCtr.tableParamsConfirm.data[i];
							var quantity = 0;
							totalApprovalQuantity=totalApprovalQuantity+parseInt(item.approvalQuantity);
							if(parseInt(item.approvalQuantity)>0){
								if(transferInfoCtr.getItemProductArray(item.productLst,item.productId).seriesIndicator==1){
									for (var j = 0, length = item.seriesLst.length; j < length; j++) {
										var seriesDTO = item.seriesLst[j];
										if (parseInt(seriesDTO.seriesFrom) > parseInt(seriesDTO.seriesTo)) {
											$scope.addAlert('Từ số seri phải nhỏ hơn đến số seri.','error');
											transferInfoCtr.seriesInvalid=true;
											break;
										}
										var minusSeries = parseInt(seriesDTO.seriesTo) - parseInt(seriesDTO.seriesFrom) + 1;
										quantity += minusSeries;
									}
									if(!transferInfoCtr.seriesInvalid){
										if (quantity != parseInt(item.approvalQuantity)) {
											$scope.addAlert('Số seri không bằng số lượng duyệt, vui lòng xem lại!',
													'error');
											transferInfoCtr.seriesInvalid=true;
											break;
										}
									}
								}
							}
						}
						if(totalApprovalQuantity>0){
							if(!transferInfoCtr.seriesInvalid){
								transferInfoCtr.transferRequestDTO.detailAppLst=transferInfoCtr.tableParamsConfirm.data;
								HoTransferService.post({
									uri : 'doApproveRequest'
								}, transferInfoCtr.transferRequestDTO, function(result) {
									if (result.flagError!=null&&result.flagError==0) {
										if(paramSearch!=undefined){
											window.location.href = GLOBAL_URL
											+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
											+ '/'
											+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW
											+ '/'
											+ $base64
													.encode(paramSearch);
										}else{
											window.location.href = GLOBAL_URL
											+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
											+ '/'
											+ transferInfoCtr.CONST_EXPORTS.APPROVE_STATUS_VIEW;
										}
										$scope.loading = false;
									}else{
										$scope.loading = false;	
									}
								}, function(error) {
									if(error.status == '403') {
										$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
									}
									$scope.loading = false;
								});
							}else{
								$scope.loading = false;
							}
						}else{
							$scope.loading = false;
							$scope.addAlert('Tổng số lượng duyệt phải lớn hơn 0.Vui lòng kiểm tra lại','error');
						}
					}
				}else{
					$scope.loading = false;
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		}
		//action finish request
		transferInfoCtr.finish = function() {
			HoTransferService.query({uri : 'getStockByOffice'}).$promise.then(function(result){
				if(result[0].flagError==0){
					$scope.loading = true;
					transferInfoCtr.transferRequestDTO.detailLst=transferInfoCtr.tableParams.data;
					HoTransferService.post({
						uri : 'doFinishRequest'
					}, transferInfoCtr.transferRequestDTO, function(result) {
						if (result.flagError!=null&&result.flagError==0) {
							if(paramSearch!=undefined){
								window.location.href = GLOBAL_URL
								+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER_SEARCH
								+ '/'
								+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW
								+ '/'
								+ $base64
										.encode(paramSearch);
							}else{
								window.location.href = GLOBAL_URL
								+ transferInfoCtr.CONST_EXPORTS.URL_HOTRANSFER
								+ '/'
								+ transferInfoCtr.CONST_EXPORTS.CREATE_STATUS_VIEW;
							}
							$scope.loading = false;
						}else{
							$scope.loading = false;	
						}
					}, function(error) {
						$scope.loading = false;
					});
				}else{
					$scope.loading = false;
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
			});
		}
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		$scope.format = $scope.formats[2];
		$scope.altInputFormats = [ 'M!/d!/yyyy' ];
		transferInfoCtr.popupDod = {
			opened : false
		};

	}

})();
